module.exports = __webpack_public_path__ + "img/white.edc729a5.png";